import React, { useEffect, useRef, useState } from 'react'
import useInputValidate from '../../hooks/useInputValidate'
import { AddressIcon, CountryIcon, DepartmentIcon, EmailIcon, IdIcon, MobileIcon, RoleIcon, UserIcon} from '../iconSet/IconSet'
import { CreateUserPropsType, TabTypes } from './CreateUserType'
import InputGroup from '../inputComp/InputGroup'
import DragDropUpload from '../inputComp/DragDropUpload'
import { SelectItemTypes } from '../../CommonTypes'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import { APICall } from '../../services/APIService'
import { API_GET_ALL_DEPARTMENT_URL, APIGetAllDepartmentDataResponseType } from '../../services/APIDepartmentService'
import { API_GET_ALL_ROLES, APIResponseGetAllRolesType } from '../../services/APIAuthorizationService'

const CreateUser = (props: CreateUserPropsType) => {

    const tabs: string[] = ['create_user', 'policies']
    const [selectedTab, setSelectedTab] = useState<TabTypes>('create_user')

    const [userDepartment, setUserDepartment] = useState<SelectItemTypes[]>([
        {value: 'all_departments', name: 'All Departments'},
        {value: 'dmc', name: 'DMC'},
        {value: 'ird-ews', name: 'IRD-EWS'},
        {value: 'la', name: 'LA'},
        {value: 'nbro', name: 'NBRO'},
        {value: 'ew_department', name: 'EW Department'},
        {value: 'ewd_department', name: 'EWD Department'},
        {value: 'thinklab', name: 'Thinklab'}
    ])

    const [selectRole, setSelectRole] = useState<SelectItemTypes[]>([
        {value: 'director_general', name: 'Director General'},
        {value: 'director', name: 'Director'},
        {value: 'senior_officer', name: 'Senior Officer'},
        {value: 'officer', name: 'Officer'},
        {value: 'district_officer', name: 'District Officer'},
        {value: 'district_secretary', name: 'District Secretary'}
    ])

    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const countryRef = useRef<HTMLInputElement | null>(null)
    const usernameRef = useRef<HTMLInputElement | null>(null)
    const firstNameRef = useRef<HTMLInputElement | null>(null)
    const lastNameRef = useRef<HTMLInputElement | null>(null)
    const addressRef = useRef<HTMLInputElement | null>(null)
    const mobileNumberRef = useRef<HTMLInputElement | null>(null)
    const departmentRef = useRef<HTMLSelectElement | null>(null)
    const roleRef = useRef<HTMLSelectElement | null>(null)
    const emailRef = useRef<HTMLInputElement | null>(null)
    const nicNumberRef = useRef<HTMLInputElement | null>(null)

    const mprMeghaRef = useRef<HTMLInputElement | null>(null)
    const mprVisuraRef = useRef<HTMLInputElement | null>(null)
    const mprVisuraDashboardRef = useRef<HTMLInputElement | null>(null)
    const mprBackOfficeSystemRef = useRef<HTMLInputElement | null>(null)

    const formItems: InputGroupPropsTypes[] = [
        {
            type: 'text',
            icon: <CountryIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Select country',
            label: 'Country',
            componentInputElement: countryRef,
            name: 'country',
            required: true,
            disabled: true,
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter username',
            label: 'Username',
            componentInputElement: usernameRef,
            name: 'username',
            required: true,
            disabled: true,
        },
        {
            type: 'text',
            icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter first name',
            label: 'First Name',
            name: 'firstName',
            componentInputElement: firstNameRef,
        },
        {
            type: 'text',
            icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter last name',
            label: 'Last Name',
            name: 'lastName',
            componentInputElement: lastNameRef,
        },
        {
            type: 'text',
            icon: <AddressIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter address',
            label: 'Address',
            name: 'address',
            componentInputElement: addressRef,
        },
        {
            type: 'text',
            icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter mobile number',
            label: 'Mobile Number',
            name: 'mobileNumber',
            componentInputElement: mobileNumberRef,
        },
        {
            type: 'select',
            icon: <DepartmentIcon width="1.3rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'Department',
            componentSelectElement: departmentRef,
            optionList: userDepartment,
            placeholder: 'select department',
            name: 'department',
        },
        {
            type: 'select',
            icon: <RoleIcon width="1.3rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'Select Role',
            componentSelectElement: roleRef,
            required: true,
            optionList: selectRole,
            placeholder: 'select role',
            name: 'role',
        },
        {
            type: 'text',
            icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter email',
            label: 'Email',
            name: 'email',
            componentInputElement: emailRef,
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter NIC number',
            label: 'NIC Number',
            name: 'nic',
            componentInputElement: nicNumberRef,
            required: true,
        }
    ]
    
    const [file, setFile] = useState<File[]>([])

    // Custom hook
    const {validateField} = useInputValidate()

    // Handle create user next button click
    const handleCreateUserNextClick = () => {
        const country = validateField(countryRef)
        const username = validateField(usernameRef)
        const nic = validateField(nicNumberRef)

        if(country && username && nic)
        {
            setSelectedTab('policies')
        }
    }

    // Handle polices back button click
    const handlePoliceBackClick = () => {
        setSelectedTab('create_user')
    }

    // Handle polices finish button click
    const handlePolicesFinishClick = () => {
        console.log("clicked finish button")
    }

    useEffect(() => {
        if(countryRef.current && usernameRef.current){
            countryRef.current.value = 'Sri Lanka'
            usernameRef.current.value = 'user_1'
        }
        
    }, [])

    useEffect(() => {
        setIsLoading(true)
        getAllDepartments()
        getAllRoles()
        setIsLoading(false)
    }, [])

    // Get all departments
    const getAllDepartments = async () => {

        try
        {
            const response = await APICall(API_GET_ALL_DEPARTMENT_URL, 'GET', null)
        
            if(response.data){
                const responseData: APIGetAllDepartmentDataResponseType[] = response.data
                const fetchedDepartments: SelectItemTypes[] = []
                
                responseData.map(item => {
                    fetchedDepartments.push({value: item.id, name: item.name})
                })
    
                setUserDepartment(fetchedDepartments)
            }
        }
        catch(error)
        {
            console.log('data fetching error')
        }
    }

    // Get all roles
    const getAllRoles = async () => {

        try
        {
            const response = await APICall(API_GET_ALL_ROLES, 'GET', null)

            if(response.data){
                const responseData: APIResponseGetAllRolesType[] = response.data
                const fetchedDepartments: SelectItemTypes[] = []
                
                responseData.map(item => {
                    fetchedDepartments.push({value: item.id, name: item.role})
                })
    
                setSelectRole(fetchedDepartments)
            }
        }
        catch(error)
        {
            console.log('department server not responding')
        }
    }

    // Handle tab click
    const handleTabClick = (tab: string) => {
        setSelectedTab(tab as TabTypes)
    }

    return (
        <div className={`container-wrapper`}>
            <span className={`title`}>user registration</span>
            <div className='tab-area'>
                {tabs.map((tab, index) => (
                    <span key={index} style={{borderStyle: selectedTab === tab ? 'solid' : 'none'}} onClick={() => handleTabClick(tab)}>{tab.replace(/_/g, ' ')}</span>
                ))}
            </div>
            
            {/* Megha -> create user -> create user */}
            <div style={{display: selectedTab === 'create_user' ? 'block' : 'none', width: '100%', height: '100%'}}>
                <div className={`create-user`}>
                    <div className={`grid-layout-create-user`}>
                        <div className={`left-side`}>
                            {formItems.slice(0, 6).map((field, index) => (
                                <InputGroup key={index} {...field}/>
                            ))}
                        </div>

                        <div className={`right-side`}>
                            {formItems.slice(6).map((field, index) => (
                                <InputGroup key={index} {...field}/>
                            ))}
                            <div className={`drag-drop-uploader`}>
                                <DragDropUpload label='Select profile' files={file} setFile={setFile}/>
                            </div>
                        </div>

                        <div className={`checkbox-wrapper`}>
                            <div className={`checkbox-container`}>
                                <span className={`title`}>main policy roles</span>
                                <div className={'wrapper'}>
                                    <div className={`item`}>
                                        <input type="checkbox" name="" id="ur_checkbox_megha" ref={mprMeghaRef}/>
                                        <label htmlFor="ur_checkbox_megha">megha</label>
                                    </div>
                                    <div className={`item`}>
                                        <input type="checkbox" name="" id="ur_checkbox_visura" ref={mprVisuraRef}/>
                                        <label htmlFor="ur_checkbox_visura">visura</label>
                                    </div>
                                    <div className={`item`}>
                                        <input type="checkbox" name="" id="ur_checkbox_visura_dashboard" ref={mprVisuraDashboardRef}/>
                                        <label htmlFor="ur_checkbox_visura_dashboard">visura dashboard</label>
                                    </div>
                                    <div className={`item`}>
                                        <input type="checkbox" name="" id="ur_checkbox_back_office_system" ref={mprBackOfficeSystemRef}/>
                                        <label htmlFor="ur_checkbox_back_office_system">back office system</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                            <div className={`left-side`}></div>
                            <div className={`right-side`}>
                                <button className={`button-normal`} onClick={(e) => handleCreateUserNextClick()}>next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Megha -> create user -> polices */}
            <div style={{display: selectedTab === 'policies' ? 'block' : 'none', width: '100%', height: '100%'}}>
                <div className={`create-user`}>
                    <div className={`grid-layout-polices`}>
                        polices
                    </div>
                    <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                        <div className={`left-side`}>
                            <button className={`button-normal`} onClick={(e) => handlePoliceBackClick()}>back</button>
                        </div>
                        <div className={`right-side`}>
                            <button className={`button-normal`} onClick={(e) => handlePolicesFinishClick()}>finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser